import React, { useState, useMemo } from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { AdminSurveyScreenListItemDto, ScreenType } from '@wellverse/shared-ts';

export const SurveyScreenList: React.FC = () => {
  const { tableProps } = useTable<AdminSurveyScreenListItemDto>({
    resource: 'survey-screens',
    pagination: { current: 1, pageSize: 20 },
  });

  const [searchText, setSearchText] = useState('');

  const filteredData = useMemo(() => {
    if (!searchText) return tableProps.dataSource;
    const lower = searchText.toLowerCase();
    return tableProps.dataSource?.filter((item: any) =>
      item.screenKey?.toLowerCase().includes(lower)
    );
  }, [tableProps.dataSource, searchText]);

  return (
    <List resource="survey-screens">
      <div style={{ marginBottom: 16 }}>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search by screen key..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 320 }}
          allowClear
        />
      </div>
      <Table {...tableProps} dataSource={filteredData} rowKey="id">
        <Table.Column dataIndex="screenKey" title="Screen Key" />
        <Table.Column
          dataIndex="type"
          title="Type"
          filters={Object.values(ScreenType).map((t) => ({ text: t, value: t }))}
          onFilter={(value, record: any) => record.type === value}
        />
        <Table.Column dataIndex="orderIndex" title="Order" />
        <Table.Column dataIndex="questionCount" title="Questions" />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_, record: AdminSurveyScreenListItemDto) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} resource="survey-screens" />
              <ShowButton hideText size="small" recordItemId={record.id} resource="survey-screens" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="survey-screens" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
